import styled from 'styled-components';

export const SheetDetail = styled.div`
  margin: 0 -16px;
`;

export const Actions = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;

  &[data-count='1'] {
    grid-template-columns: 1fr;
  }

  &[data-count='3'] {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

export const ActionButton = styled.button`
  display: inline-flex;
  gap: 6px;
  align-items: center;
  justify-content: center;
  min-width: 0;
  height: 44px;
  padding: 0 8px;
  font: inherit;
  font-weight: 500;
  color: #262626;
  cursor: pointer;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;

  &[data-tone='primary'] {
    color: #000;
    background: #f78e1e;
    border-color: #f78e1e;
  }

  &[data-tone='danger'] {
    color: #cf1322;
    border-color: #ffa39e;
  }

  &:disabled {
    cursor: wait;
    opacity: 0.7;
  }
`;
